<script>
import { CLIENT_BENCHMARK_KEY } from '@utils/clienteBenchmark'

export default {
  name: 'BenchmarksMenu',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    benchmarks: {
      type: Array,
      default: () => [],
    },
    clienteBenchmarkMeta: {
      type: Object,
      default: null,
    },
    availableBenchmarkNames: {
      type: Set,
      default: () => new Set(),
    },
    showAddBenchmark: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      CLIENT_BENCHMARK_KEY,
    }
  },
  computed: {
    selectedProxy: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
  },
  methods: {
    onChange() {
      this.$emit('change')
    },
  },
}
</script>

<template>
  <v-menu offset-y left nudge-bottom="8" :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <BaseButton secondary text sm v-bind="attrs" v-on="on">
        <icon-svg name="mdi-plus" :size="16" color="primary" />
        Benchmarks
      </BaseButton>
    </template>
    <div class="bg-white benchmarks-menu__panel">
      <div class="benchmarks-menu__body">
        <v-tooltip v-if="clienteBenchmarkMeta" bottom max-width="260">
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-checkbox
                v-model="selectedProxy"
                :label="clienteBenchmarkMeta.label || 'Meu Benchmark'"
                :value="CLIENT_BENCHMARK_KEY"
                color="primary"
                dense
                hide-details
                @change="onChange"
              />
            </div>
          </template>
          <span>
            Benchmark padrão deste cliente. Para alterar, edite os dados
            cadastrais do cliente.
          </span>
        </v-tooltip>
        <v-divider v-if="clienteBenchmarkMeta" class="my-2" />
        <v-tooltip
          v-for="bench in benchmarks"
          :key="bench.id"
          bottom
          :disabled="availableBenchmarkNames.has(bench.nome)"
        >
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-checkbox
                v-model="selectedProxy"
                :label="bench.nome"
                :value="bench.id"
                :disabled="!availableBenchmarkNames.has(bench.nome)"
                color="primary"
                dense
                hide-details
                @change="onChange"
              />
            </div>
          </template>
          <span>Sem dados nessa visualização</span>
        </v-tooltip>
      </div>
      <template v-if="showAddBenchmark">
        <v-divider />
        <div
          class="benchmarks-menu__footer d-flex align-center justify-center az-gap-small pa-3"
        >
          <BaseButton
            secondary
            text
            small
            fit-content
            min-width="fit-content"
            @click="$emit('reset')"
          >
            <icon-svg name="mdi-refresh" :size="16" color="primary" />
            Resetar
          </BaseButton>
          <BaseButton
            primary
            outline
            small
            fit-content
            min-width="fit-content"
            @click="$emit('add-benchmark')"
          >
            Adicionar benchmark
          </BaseButton>
        </div>
      </template>
    </div>
  </v-menu>
</template>

<style lang="sass">
.benchmarks-menu
  &__panel
    display: flex
    flex-direction: column
    width: 320px
    max-height: 300px
    border-radius: 12px
    overflow: hidden

  &__body
    flex: 1 1 auto
    min-height: 0
    overflow-y: auto
    padding: 10px

  &__footer
    flex-shrink: 0
</style>
